import './index.less';

const LoadIcon = (props) => {
  const { color, size } = props;

  return (
    <svg
      viewBox='25 25 50 50'
      className='new-loading-icon'
      style={{
        width: size,
        height: size,
        animation: 'loading-rotate 2s linear infinite',
      }}
    >
      <circle
        cx='50'
        cy='50'
        r='20'
        fill='none'
        style={{
          strokeDasharray: '90,150',
          strokeDashoffset: 0,
          strokeWidth: 2,
          stroke: color,
          strokeLinecap: 'round',
          animation: 'loading-dash 1.5s ease-in-out infinite',
        }}
      ></circle>
    </svg>
  );
};

LoadIcon.defaultProps = {
  color: '#fff',
  size: 60,
};

export default LoadIcon;
